import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { solutionCardsData } from 'sections/Services/TradeFinance/data';
import { SolutionCardType } from 'sections/Services/TradeFinance/types';
import styles from 'sections/Services/TradeFinance/components/SectionSolutions/SectionSolutions.module.scss';

const cn = classNames.bind(styles);

const SectionSolutions = (): ReactElement => {
  const solutionCards = solutionCardsData.map((card: SolutionCardType) => {
    return (
      <div className={cn('card')} key={card.id}>
        <img
          className={cn('card__icon')}
          src={`/images/pages/Services/TradeFinance/${card.iconName}.svg`}
          alt={card.iconAlt}
        />
        <h4 className={cn('card__heading')}>
          {card.heading}
        </h4>
      </div>
    );
  });

  return (
    <section className={cn('solutions')}>
      <div className={cn('container')}>

        <h2 className={cn('solutions__heading')}>
          <span>Financing</span>{' '}
          <span>Solutions</span>
        </h2>

        <div className={cn('solutions__cards')}>
          {solutionCards}
        </div>

      </div>
    </section>
  );
};

export default SectionSolutions;